import React, { useMemo } from 'react';
import { Grid, Box, TextField, MenuItem } from '@mui/material';
import { toEnglishDigits, formatNumberInputValue } from '../../../../utils/convertNumbers';

const DISCOUNT_TYPE_CHOICES = [
    { value: 'Teacher_discount', label: 'مدرس' },
    { value: 'Institute_discount', label: 'آموزشگاه' },
    { value: 'Both_discount', label: 'هر دو' },
];

export default function DiscountFields({
    discountAmount,
    discountType,
    onDiscountAmountChange,
    onDiscountTypeChange
}) {
    const persianDiscountAmount = useMemo(
        () => formatNumberInputValue(discountAmount),
        [discountAmount]
    );

    const handleDiscountAmountChange = (event) => {
        const rawValue = event.target.value;

        // Allow only numeric characters (Persian or English digits)
        const sanitizedValue = rawValue.replace(/[^0-9۰-۹]/g, '');
        const englishValue = toEnglishDigits(sanitizedValue);
        onDiscountAmountChange(englishValue);
    };

    return (
        <Grid item xs={12} md={6}>
            <Box 
                sx={{ 
                    display: 'flex', 
                    gap: 2,
                    flexDirection: { xs: 'column', sm: 'row' }
                }}
            >
                <TextField
                    fullWidth
                    size="small"
                    label="تخفیف (تومان)"
                    type="text"
                    value={persianDiscountAmount}
                    onChange={handleDiscountAmountChange}
                    inputProps={{
                        min: 0,
                        inputMode: 'numeric',
                        pattern: '[0-9۰-۹]*',
                        dir: 'rtl'
                    }}
                    InputLabelProps={{ shrink: true }}
                    sx={{
                        flex: 1,
                        '& input': {
                            '&::-webkit-outer-spin-button': {
                                '-webkit-appearance': 'none',
                                margin: 0,
                            },
                            '&::-webkit-inner-spin-button': {
                                '-webkit-appearance': 'none',
                                margin: 0,
                            },
                            '&[type=number]': {
                                '-moz-appearance': 'textfield',
                            },
                        },
                        '& .MuiInputBase-root': {
                            height: '40px',
                        },
                    }}
                />
                <Box sx={{ flex: 1 }}>
                    <TextField
                        fullWidth
                        size="small"
                        select
                        label="نوع تخفیف"
                        value={discountType}
                        onChange={(e) => onDiscountTypeChange(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                            '& .MuiInputBase-root': {
                                height: '40px',
                            },
                        }}
                    >
                        {DISCOUNT_TYPE_CHOICES.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Box>
            </Box>
        </Grid>
    );
}

